// https://swiperjs.com/get-started
import SwiperCore, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay]);
import 'swiper/swiper-bundle.css';

const swiper = new SwiperCore('.swiper-container', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
    autoplay: {
        delay: 2500,
    },
    speed: 1000,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

const swiperTeam = new SwiperCore('.swiper-container-team', {
  // Optional parameters
  slidesPerView: 1,
  direction: 'horizontal',
  loop: false,
  watchSlidesVisibility: true,

  breakpoints: {
       // when window width is >= 320px
       640: {
         slidesPerView: 2,
       },
       // when window width is >= 480px
       1024: {
         slidesPerView: 3,
       },
   },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});
